// extracted by mini-css-extract-plugin
export default {"container":"Section_container__AMNFT","verticalAlign":"Section_verticalAlign__h5Aoy","flexContainer":"Section_flexContainer__7ThVg"};